import 'babel-polyfill';
import { instance } from '../utils/axiosInstance'


export class ProductApi {

    static async getAttributes() {
        return instance.get('/product_attributes');
    }

    static async createAttribute(attribute){
        return instance.post('product_attribute', attribute)
    }
    static async createProductType(productType){
        return instance.post('/product_type', productType)
    }

    static async getProductTypes(){
        return instance.get('/product_types')
    }

    static async getBrands(){
        return instance.get('/brands')
    }

    static async createProduct(product){
        return instance.post('/product', product)
    }

    static async get(productId){
        return instance.get('/product/' + productId)
    }

    static async getMetrics(productId){
        return instance.get('product/' + productId+ '/metrics')
    }

    static async getCatalogReport(){
        const params = {'img': false, 'stock': false}
        return instance.get('products', {params:params})

    }
    static async updateCatalog(updatedProducts){
        return instance.put('/products', updatedProducts)
    }
    static  async updateProduct(productId, productData){
        return instance.put('/product/' + productId, productData)
    }

    static async createCombo(combo){
        return instance.post('/combo', combo)
    }
    static async getCombo(comboId){
        return instance.get('/combo/' + comboId)
    }
    static async getComboReport(){
        return instance.get('/combos')
    }
    static  async updateCombos(comboData){
        return instance.put('/combos', comboData)
    }


}


// WEBPACK FOOTER //
// ./src/api/product_api.js